/*@flow*/
import set from 'ops/set';

const PATHS = {
  toasterStatus: 'ui.toaster.type',
  toasterMessage: 'ui.toaster.message',
  toasterDuration: 'ui.toaster.duration',
};

export const closeToaster = () => {
  set(PATHS.toasterStatus, 'Closed');
};

export default function toast(message: any, durationMS: number = 5000) {
  set(PATHS.toasterDuration, durationMS);
  set(PATHS.toasterStatus, 'Closed');
  set(PATHS.toasterMessage, message);
  set(PATHS.toasterStatus, 'Open');
}

function slowToast(message: React$Node) {
  toast(message, 500000);
}

export function useToaster(): {|closeToaster: () => void, slowToast: (message: React$Node) => void|} {
  return { slowToast, closeToaster };
}
